import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Quotes() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [quotes, setQuotes] = useState<any[]>([]);

  useEffect(() => {
    // Simulate loading quotes
    setTimeout(() => {
      setQuotes([
        {
          id: 1,
          provider: 'بقالة الخير',
          rating: 4.9,
          price: 167,
          deliveryTime: '30-45 دقيقة',
          distance: '2.5 كم',
          image: 'https://public.readdy.ai/ai/img_res/23311671cb76f815e4769eb8f970deba.jpg'
        },
        {
          id: 2,
          provider: 'متجر الطازج',
          rating: 4.7,
          price: 172,
          deliveryTime: '40-55 دقيقة',
          distance: '3.8 كم',
          image: 'https://readdy.ai/api/search-image?query=fresh%20market%20store%2C%20professional%20photography%2C%20clean%20storefront%2C%20bright%20lighting%2C%20commercial%20photo&width=100&height=100&seq=q2&orientation=squarish'
        },
        {
          id: 3,
          provider: 'سوبر ماركت النخيل',
          rating: 4.8,
          price: 165,
          deliveryTime: '35-50 دقيقة',
          distance: '3.2 كم',
          image: 'https://readdy.ai/api/search-image?query=supermarket%20exterior%2C%20professional%20photography%2C%20clean%20storefront%2C%20bright%20lighting%2C%20commercial%20photo&width=100&height=100&seq=q3&orientation=squarish',
          recommended: true
        }
      ]);
      setLoading(false);
    }, 2000);
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen bg-[#F6F6F6] flex flex-col items-center justify-center" style={{ fontFamily: 'Cairo, sans-serif' }}>
        <div className="w-24 h-24 mb-6">
          <div className="w-full h-full border-4 border-[#0D47A1] border-t-transparent rounded-full animate-spin"></div>
        </div>
        <h2 className="text-[#212121] text-xl font-bold mb-2">جاري استلام العروض...</h2>
        <p className="text-gray-500 text-sm">يرجى الانتظار</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#F6F6F6] pb-24" style={{ fontFamily: 'Cairo, sans-serif' }}>
      {/* Top Navigation */}
      <div className="fixed top-0 left-0 right-0 bg-gradient-to-r from-[#0D47A1] to-[#1976D2] z-50">
        <div className="px-4 py-4 flex items-center gap-3">
          <button onClick={() => navigate('/address')} className="w-10 h-10 flex items-center justify-center">
            <i className="ri-arrow-right-line text-white text-2xl"></i>
          </button>
          <div className="flex-1">
            <h1 className="text-white text-lg font-bold">عروض الأسعار</h1>
            <p className="text-white/80 text-xs">{quotes.length} عروض متاحة</p>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="pt-24 px-4">
        {/* Info Banner */}
        <div className="bg-gradient-to-r from-[#FF8F00]/10 to-[#FF8F00]/5 border border-[#FF8F00]/20 rounded-2xl p-4 mb-4 flex items-start gap-3">
          <i className="ri-information-fill text-[#FF8F00] text-xl flex-shrink-0 mt-0.5"></i>
          <div>
            <h3 className="text-[#212121] font-bold text-sm mb-1">اختر العرض المناسب</h3>
            <p className="text-gray-600 text-xs leading-relaxed">
              تم إرسال طلبك لعدة متاجر. اختر العرض الأفضل من حيث السعر ووقت التوصيل
            </p>
          </div>
        </div>

        {/* Quotes List */}
        <div className="space-y-3">
          {quotes.map((quote) => (
            <div
              key={quote.id}
              className={`bg-white rounded-2xl p-5 shadow-sm ${
                quote.recommended ? 'border-2 border-[#4CAF50]' : ''
              }`}
            >
              {quote.recommended && (
                <div className="bg-[#4CAF50] text-white text-xs font-bold px-3 py-1 rounded-full inline-flex items-center gap-1 mb-3">
                  <i className="ri-star-fill"></i>
                  الأفضل قيمة
                </div>
              )}

              <div className="flex items-start gap-3 mb-4">
                <div className="w-16 h-16 bg-gray-100 rounded-xl overflow-hidden flex-shrink-0">
                  <img src={quote.image} alt={quote.provider} className="w-full h-full object-cover" />
                </div>
                <div className="flex-1">
                  <h3 className="text-[#212121] font-bold mb-1">{quote.provider}</h3>
                  <div className="flex items-center gap-3 text-xs text-gray-600">
                    <span className="flex items-center gap-1">
                      <i className="ri-star-fill text-[#FF8F00]"></i>
                      {quote.rating}
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-map-pin-line"></i>
                      {quote.distance}
                    </span>
                  </div>
                </div>
                <div className="text-left">
                  <div className="text-[#0D47A1] text-2xl font-bold">{quote.price}</div>
                  <div className="text-gray-500 text-xs">ر.س</div>
                </div>
              </div>

              <div className="bg-[#F6F6F6] rounded-xl p-3 mb-4">
                <div className="flex items-center justify-between text-sm">
                  <span className="text-gray-600 flex items-center gap-2">
                    <i className="ri-time-line text-[#0D47A1]"></i>
                    وقت التوصيل
                  </span>
                  <span className="text-[#212121] font-bold">{quote.deliveryTime}</span>
                </div>
              </div>

              <button
                onClick={() => navigate('/payment')}
                className="w-full bg-gradient-to-r from-[#0D47A1] to-[#1976D2] text-white py-3 rounded-xl font-bold shadow-lg active:scale-95 transition-transform"
              >
                اختيار هذا العرض
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}